import { Modal } from '@mui/material';

type RightPanelOverlayModalProps = {
  open: boolean;
  onClose: () => void;
  children: React.ReactElement;
};

const getMainEl = () => document.getElementById('fuse-main')!;

export default function RightPanelOverlayModal({
  open,
  onClose,
  children,
}: RightPanelOverlayModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      container={getMainEl}
      sx={{
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      slotProps={{
        backdrop: {
          sx: {
            position: 'absolute',
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
          },
        },
      }}
    >
      {children}
    </Modal>
  );
}
